import React from 'react';
import _ from 'lodash';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { NavLink, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar } from 'antd';
import {
  faCog,
  faUniversity,
  faUser,
  faUsers,
  faHome,
  faSignOut,
  faFileAlt,
  faUpload,
  faHistory,
  faBus,
  faReceipt,
  faTasks,
  faDatabase,
  faCogs,
  faFile
} from '@fortawesome/pro-duotone-svg-icons';
import { useTranslation } from 'react-i18next';
import {
  userAtom,
  tokenAtom,
  userPrivilagesAtom,
  menuSideBarAtom
} from '../../../../atoms/Atoms';
import envConfig from '../../../../envConfig';

function AuthenticatedSideBar() {
  const history = useHistory();
  const { t } = useTranslation();
  const [user, setUser] = useRecoilState(userAtom);
  const setToken = useSetRecoilState(tokenAtom);
  const setIsMenuOpen = useSetRecoilState(menuSideBarAtom);
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  function signOut() {
    const promise = new Promise(function (resolve, reject) {
      setIsMenuOpen(false);
      window.localStorage.removeItem(`${envConfig.StoragePrefix}-user`);
      window.localStorage.removeItem(`${envConfig.StoragePrefix}-token`);
      setToken(null);
      resolve();
    });
    promise.then(() => {
      setUser(null);
    })
    .then(() => {
      history.push('/');
    });
  }

  return (
    <div className="sidebar bg-sidebar flex flex-col flex-1 overflow-auto divide-y divide-gray-100">
      <NavLink
        exact
        to="/profile"
        activeClassName="bg-sidebarSelected text-sidebarSelectedText"
        onClick={() => setIsMenuOpen(false)}
        className="px-4 py-3 flex items-center space-x-3 text-sm tracking-tight transition-colors duration-200 ease-linear text-sidebarText hover:bg-sidebarSelected hover:text-sidebarSelectedText ring-0 focus:ring-0 outline-none focus:outline-none"
      >
        <Avatar className="bg-primaryColor" src={user?.avatar} />
        <div>{user?.completeName}</div>
      </NavLink>
      <NavLink
        exact
        to="/"
        activeClassName="bg-sidebarSelected text-sidebarSelectedText"
        onClick={() => setIsMenuOpen(false)}
        className="px-4 py-3 flex items-center space-x-3 text-sm tracking-tight transition-colors duration-200 ease-linear text-sidebarText hover:bg-sidebarSelected hover:text-sidebarSelectedText ring-0 focus:ring-0 outline-none focus:outline-none"
      >
        <FontAwesomeIcon icon={faHome} />
        <div>{t('home')}</div>
      </NavLink>
      
      {userPrivilages?.hasCloserAdminPrivilages && (
        <NavLink
          exact
          to="/admin"
          activeClassName="bg-sidebarSelected text-sidebarSelectedText"
          onClick={() => setIsMenuOpen(false)}
          className="px-4 py-3 flex items-center space-x-3 text-sm tracking-tight transition-colors duration-200 ease-linear text-sidebarText hover:bg-sidebarSelected hover:text-sidebarSelectedText ring-0 focus:ring-0 outline-none focus:outline-none"
        >
          <FontAwesomeIcon icon={faCogs} />
          <div>{t('admin')}</div>
        </NavLink>
      )}
      {userPrivilages?.hasCloserAdminPrivilages && (
        <NavLink
          exact
          to="/leads"
          activeClassName="bg-sidebarSelected text-sidebarSelectedText"
          onClick={() => setIsMenuOpen(false)}
          className="px-4 py-3 flex items-center space-x-3 text-sm tracking-tight transition-colors duration-200 ease-linear text-sidebarText hover:bg-sidebarSelected hover:text-sidebarSelectedText ring-0 focus:ring-0 outline-none focus:outline-none"
        >
          <FontAwesomeIcon icon={faFileAlt} />
          <div>{t('my_opportunities')}</div>
        </NavLink>
      )}
      {userPrivilages.hasSetter && (
        <NavLink
          exact
          to="/setter/leads"
          activeClassName="bg-sidebarSelected text-sidebarSelectedText"
          onClick={() => setIsMenuOpen(false)}
          className="px-4 py-3 flex items-center space-x-3 text-sm tracking-tight transition-colors duration-200 ease-linear text-sidebarText hover:bg-sidebarSelected hover:text-sidebarSelectedText ring-0 focus:ring-0 outline-none focus:outline-none"
        >
          <FontAwesomeIcon icon={faFileAlt} />
          <div>{t('my_leads')}</div>
        </NavLink>
      )}
      <div className="mx-4 md:mx-0 flex items-center justify-between px-12 py-2 mt-4 rounded-full bg-rose-500 hover:bg-rose-600 hover:scale-125 transition duration-200 ease-in-out">
        <button
          type="button"
          className="flex text-sm items-center font-medium text-white h-full w-24 ring-0 outline-none focus:ring-0 focus:outline-none"
          onClick={() => signOut()}
        >
          <FontAwesomeIcon className="mr-2" icon={faSignOut} />
          {t('sign_out')}
        </button>
      </div>
    </div>
  );
}

export default AuthenticatedSideBar;
